import { ExclamationCircleOutlined, TranslationOutlined } from '@ant-design/icons';
import { Alert, Button, message, Modal, Space, Switch, Tag } from 'antd';
import gql from 'graphql-tag';
import { useState } from 'react';
import { useAuthedMutationWithNotification } from 'utils/qlAuth';

export const StoryController_BuildFlyFrames = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [cleanAndBuildFrames, answerBuildTts] = useAuthedMutationWithNotification(gql`
    mutation StoryController_BuildFlyFrames($id: Int!) {
      StoryController_BuildFlyFrames(id: $id) {
        id
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        try {
          setInLoading(true);
          message.info('ReBuild story frames start');
          await cleanAndBuildFrames({ variables: { id: Number(props.storyId) } });
          message.success('ReBuild story frames Done');
          setInLoading(false);
          props.qStory.refetch();
        } catch (e) {
          console.log(e);
          setInLoading(false);
        }
      }}
    >
      Build fly story plan
    </Button>
  );
};
export const StoryController_BuildStoryPlan = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [cleanAndBuildFrames, answerBuildTts] = useAuthedMutationWithNotification(gql`
    mutation StoryController_BuildStoryPlan($id: Int!) {
      StoryController_BuildStoryPlan(id: $id) {
        answer
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      loading={inLoading}
      size="small"
      onClick={async () => {
        try {
          setInLoading(true);
          message.info('ReBuild story frames start');
          await cleanAndBuildFrames({ variables: { id: Number(props.storyId) } });
          message.success('ReBuild story frames Done');
          setInLoading(false);
          props.qStory.refetch();
        } catch (e) {
          console.log(e);
          setInLoading(false);
        }
      }}
    >
      Build story plan
    </Button>
  );
};

export const SpectacleController_generateSpectacle = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [generateSpectacle, answerDescription] = useAuthedMutationWithNotification(gql`
    mutation SpectacleController_generateSpectacle($id: Int!) {
      SpectacleController_generateSpectacle(id: $id) {
        id
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        try {
          setInLoading(true);
          message.info('Build generateSpectacle start');
          await generateSpectacle({ variables: { id: Number(props.storyId) } });
          message.success('Build generateSpectacle Done');
          setInLoading(false);
          props.qStory.refetch();
        } catch (e) {
          console.log(e);
          setInLoading(false);
        }
      }}
    >
      Generate spectacle
    </Button>
  );
};

export const StoryController_generateTitleAndDescription = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [generateTitleAndDescription, answerDescription] = useAuthedMutationWithNotification(gql`
    mutation StoryController_generateTitleAndDescription($id: Int!) {
      StoryController_generateTitleAndDescription(id: $id) {
        answer
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        try {
          setInLoading(true);
          message.info('Build title and description start');
          await generateTitleAndDescription({ variables: { id: Number(props.storyId) } });
          message.success('Build title and description Done');
          setInLoading(false);
          props.qStory.refetch();
        } catch (e) {
          console.log(e);
          setInLoading(false);
        }
      }}
    >
      Build title and description
    </Button>
  );
};

export const StoryController_createFrames = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [cleanAndBuildFrames, answerBuildTts] = useAuthedMutationWithNotification(gql`
    mutation StoryController_createFrames($storyId: Int!) {
      StoryController_createFrames(storyId: $storyId) {
        id
      }
    }
  `);
  const story = props?.qStory.data?.StoryController_getStoryById || {};

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Do you want build frames?`,
          icon: <ExclamationCircleOutlined />,
          content: (
            <>
              Генерация фреймов алгоритмом <Tag>{story?.type}</Tag>
              <hr />
            </>
          ),
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Create frames start');
              await cleanAndBuildFrames({ variables: { storyId: Number(props.storyId) } });
              message.success('Create frames Done');
              setInLoading(false);
              props.qStory.refetch();
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Create frames
    </Button>
  );
};

export const StoryController_removeFrames = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [doMutation, answerBuildTts] = useAuthedMutationWithNotification(gql`
    mutation StoryController_removeFrames($storyId: Int!) {
      StoryController_removeFrames(storyId: $storyId)
    }
  `);

  return (
    <Button
      disabled={inLoading}
      type="dashed"
      size="small"
      danger
      onClick={async () => {
        Modal.confirm({
          title: `Do you want clean frames?`,
          icon: <ExclamationCircleOutlined />,
          content: (
            <>
              Удалит все фреймы для истории.
              <hr />
              Не рекомендуется использовать, если фреймы уже имеют картинки или видео.
            </>
          ),
          onOk: async () => {
            try {
              setInLoading(true);
              await doMutation({ variables: { storyId: Number(props.storyId) } });
              message.success('Done');
              setInLoading(false);
              props.qStory.refetch();
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Remove frames
    </Button>
  );
};

export const FrameImportController_importFramesFromFolder = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [doAction, answer] = useAuthedMutationWithNotification(gql`
    mutation FrameImportController_importFramesFromFolder($storyId: Int!) {
      FrameImportController_importFramesFromFolder(storyId: $storyId) {
        id
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Do you want import frames?`,
          icon: <ExclamationCircleOutlined />,
          content: <>Импорт картинок, видео и промтов из папки</>,
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Import started');
              await doAction({ variables: { storyId: Number(props.storyId) } });
              message.success('Import done');
              setInLoading(false);
              props.qStory.refetch();
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Import frames
    </Button>
  );
};

export const FrameImportController_importFramesFromLeonardo = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [doAction, answer] = useAuthedMutationWithNotification(gql`
    mutation FrameImportController_importFramesFromLeonardo($storyId: Int!) {
      FrameImportController_importFramesFromLeonardo(storyId: $storyId) {
        id
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Do you want import frames?`,
          icon: <ExclamationCircleOutlined />,
          content: (
            <Space direction="vertical">
              Импорт промтов из Leonardo для ранее импортированных картинок.
              <Alert message="Устарело. Теперь импорт картинок сразу идёт с импортом промтов" type="error" />
            </Space>
          ),
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Import started');
              await doAction({ variables: { storyId: Number(props.storyId) } });
              message.success('Import done');
              setInLoading(false);
              props.qStory.refetch();
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Import from Leonardo
    </Button>
  );
};

export const StoryController_copyStory = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [copyStory] = useAuthedMutationWithNotification(gql`
    mutation StoryController_copyStory($id: Int!, $copyFrames: Boolean!) {
      StoryController_copyStory(id: $id, copyFrames: $copyFrames) {
        id
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Do you want to copy this story?`,
          width: 600,
          icon: <ExclamationCircleOutlined />,
          content: `A new copy of the story will be created.`,
          okText: 'Story only',
          cancelText: 'Cancel',
          // onOk: async () => {
          //   try {
          //     setInLoading(true);
          //     message.info('Copying story...');
          //     await copyStory({ variables: { id: Number(props.storyId), copyFrames: false } });
          //     message.success('Story copied');
          //     setInLoading(false);
          //     props.qStory.refetch();
          //   } catch (e) {
          //     console.log(e);
          //     setInLoading(false);
          //   }
          // },
          // Добавляем дополнительную кнопку для копирования с кадрами
          okButtonProps: { style: { display: 'none' } }, // скрываем стандартную ok-кнопку
          footer: (_, { OkBtn, CancelBtn }) => (
            <Space direction="horizontal">
              <Button
                type="primary"
                loading={inLoading}
                onClick={async () => {
                  try {
                    setInLoading(true);
                    message.info('Copying story...');
                    await copyStory({ variables: { id: Number(props.storyId), copyFrames: false } });
                    message.success('Story copied');
                    setInLoading(false);
                    props.qStory.refetch();
                    Modal.destroyAll();
                  } catch (e) {
                    console.log(e);
                    setInLoading(false);
                  }
                }}
              >
                Story only
              </Button>
              <Button
                type="primary"
                loading={inLoading}
                onClick={async () => {
                  try {
                    setInLoading(true);
                    message.info('Copying story and frames...');
                    await copyStory({ variables: { id: Number(props.storyId), copyFrames: true } });
                    message.success('Story and frames copied');
                    setInLoading(false);
                    props.qStory.refetch();
                    Modal.destroyAll();
                  } catch (e) {
                    console.log(e);
                    setInLoading(false);
                  }
                }}
              >
                Story and frames
              </Button>
              <CancelBtn />
            </Space>
          ),
        });
      }}
    >
      Copy story
    </Button>
  );
};

export const StoryController_removeStory = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [removeStory] = useAuthedMutationWithNotification(gql`
    mutation StoryController_removeStory($storyId: Int!) {
      StoryController_removeStory(storyId: $storyId)
    }
  `);

  return (
    <Button
      disabled={inLoading}
      type="dashed"
      size="small"
      danger
      onClick={async () => {
        Modal.confirm({
          title: `Do you want to remove this story?`,
          icon: <ExclamationCircleOutlined />,
          content: `This action cannot be undone.`,
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Removing story...');
              await removeStory({ variables: { storyId: Number(props.storyId) } });
              message.success('Story removed');
              setInLoading(false);
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Remove story
    </Button>
  );
};

export const FrameImportController_importAudioFromFolder = (props: { qStory: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [doAction, answer] = useAuthedMutationWithNotification(gql`
    mutation FrameImportController_importAudioFromFolder($storyId: Int!) {
      FrameImportController_importAudioFromFolder(storyId: $storyId) {
        id
      }
    }
  `);

  const checkList = [
    <Tag>Создан - Promt template header</Tag>,
    <Tag>Создан - Promt mutator</Tag>,
    <Tag>Созданы - Переменные для описания объектов</Tag>,
    <Tag>Созданы - Переменные для описания персонажей</Tag>,
    <Tag>Созданы - Описания одежды и лица персонажа</Tag>,
    <Tag>Созданы - Описание погоды</Tag>,
    <Tag>Созданы - 2 - 3 картинки главного персонажа из переменных</Tag>,
    <Tag>Описание главного героя заимствовано из предыдущего видео?</Tag>,
  ];
  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Do you want import audio?`,
          icon: <ExclamationCircleOutlined />,
          width: 600,
          okText: 'Начинаем генерацию',
          content: (
            <>
              Будут созданы фреймы на основе аудио.
              <br />
              Если аудио ещё не импортировано, то оно будет скопировано из папки <Tag>./for-import</Tag> в папку <Tag>audio</Tag>.
              <hr />
              <Space direction="vertical">
                {checkList.map((item, index) => (
                  <Space key={index} direction="horizontal">
                    <Switch checkedChildren="Проверил" unCheckedChildren="Не проверил" /> - {item}
                  </Space>
                ))}
              </Space>
            </>
          ),
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Audio import started');
              await doAction({ variables: { storyId: Number(props.storyId) } });
              message.success('Audio import done');
              setInLoading(false);
              props.qStory.refetch();
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Create frames from audio
    </Button>
  );
};

export const StoryController_translateStory = (props: { qFrames?: any; storyId: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [doAction, answer] = useAuthedMutationWithNotification(gql`
    mutation StoryController_translateStory($storyId: Int!) {
      StoryController_translateStory(storyId: $storyId)
    }
  `);

  return (
    <Button
      title="Translate story"
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Do you want to translate this story?`,
          icon: <ExclamationCircleOutlined />,
          content: `This action will translate the story.`,
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Translation started');
              await doAction({ variables: { storyId: Number(props.storyId) } });
              message.success('Translation done');
              setInLoading(false);
              if (props?.qFrames) {
                props?.qFrames.refetch();
              }
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      <TranslationOutlined />
    </Button>
  );
};
